import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsRepeat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsRepeat"><Path fillRule="evenodd" clipRule="evenodd" d="M13 0.585938L17.4142 5.00015L13 9.41436L11.5858 8.00015L13.5858 6.00015H5V14.0002H3V4.00015H13.5858L11.5858 2.00015L13 0.585938ZM21 10.0002V20.0002H10.4142L12.4142 22.0002L11 23.4144L6.58579 19.0002L11 14.5859L12.4142 16.0002L10.4142 18.0002H19V10.0002H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsRepeat;
